/**
 * Base Input Component
 * Works on React Native and Web
 */

import React, { useState } from 'react';
import { View, TextInput, Text, StyleSheet, ViewStyle, TextStyle } from 'react-native';
import { colors, fontSizes, fontWeights } from '../theme/tokens';

interface InputProps {
  label?: string;
  placeholder?: string;
  value: string;
  onChangeText: (text: string) => void;
  secureTextEntry?: boolean;
  keyboardType?: 'default' | 'email-address' | 'numeric' | 'phone-pad';
  editable?: boolean;
  error?: string;
  testID?: string;
  style?: ViewStyle;
}

/**
 * Input Component
 */
export const Input: React.FC<InputProps> = ({
  label,
  placeholder,
  value,
  onChangeText,
  secureTextEntry = false,
  keyboardType = 'default',
  editable = true,
  error,
  testID,
  style,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const inputStyle: TextStyle = {
    paddingVertical: 10,
    paddingHorizontal: 12,
    fontSize: fontSizes.base,
    color: colors.gray9,
    borderWidth: 1,
    borderColor: isFocused ? colors.primary : error ? colors.error : colors.gray3,
    borderRadius: 8,
    backgroundColor: editable ? colors.white : colors.gray1,
    opacity: editable ? 1 : 0.6,
  };

  return (
    <View style={[{ marginVertical: 8 }, style]}>
      {label && (
        <Text
          style={{
            fontSize: fontSizes.sm,
            fontWeight: fontWeights.semibold,
            color: colors.gray9,
            marginBottom: 4,
          }}
        >
          {label}
        </Text>
      )}
      <TextInput
        style={inputStyle}
        placeholder={placeholder}
        placeholderTextColor={colors.gray5}
        value={value}
        onChangeText={onChangeText}
        secureTextEntry={secureTextEntry}
        keyboardType={keyboardType}
        editable={editable}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        testID={testID}
      />
      {error && (
        <Text
          style={{
            fontSize: fontSizes.xs,
            color: colors.error,
            marginTop: 4,
          }}
        >
          {error}
        </Text>
      )}
    </View>
  );
};

